var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea, Vendd.LazyHtmlArea, function (envelope) {

        var options = {
            url: 'api/HtmlArea/GetLazyHtmlArea',
            data: envelope.message.data.serviceConfiguration,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response && !response.d) {
                var model = response.data;
                Vendd.MessageBus.publishAsync(Vendd.LazyHtmlArea, new Vendd.LazyHtmlArea.Messages.LazyHtmlAreaSuccess(model, envelope.sender));
            }

            Vendd.MessageBus.publishAsync(Vendd.LazyHtmlArea, new Vendd.LazyHtmlArea.Messages.LazyHtmlAreaFailure());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.LazyHtmlArea, new Vendd.LazyHtmlArea.Messages.LazyHtmlAreaFailure(response));
        };

        Vendd.Service.call(options);

        return;

    });

    return Vendd;

})(Vendd || {});